import { FC } from "react";
import ReactSwitch from "react-switch";
import { themeColors } from "@common/constants";
import { SwitchProps } from "./types";

const Switch: FC<SwitchProps> = ({
  primaryColor = themeColors.green[3],
  secondaryColor = themeColors.green[3],
  onChange,
  disabled,
  checked = false,
  propagateEvents = false,
}) => {
  return (
    <div
      className={`flex h-[22px] w-[42px] items-center justify-center rounded-full border ${
        disabled
          ? "react-switch-disabled border-gray-200"
          : checked
          ? "bg-white"
          : "border-green-3 bg-green-3"
      }`}
      onClick={(e) => {
        if (!propagateEvents) {
          e.stopPropagation();
        }
      }}
    >
      <ReactSwitch
        onChange={onChange}
        onColor={primaryColor}
        offHandleColor={secondaryColor}
        offColor={"#fff"}
        checkedIcon={false}
        uncheckedIcon={false}
        checked={checked}
        borderRadius={15}
        width={40}
        height={20}
        handleDiameter={18}
        disabled={disabled}
      />
    </div>
  );
};

export default Switch;
